import { render } from "./ItemDescription.vue?vue&type=template&id=75bb0477&scoped=true"
import script from "./ItemDescription.vue?vue&type=script&lang=js"
export * from "./ItemDescription.vue?vue&type=script&lang=js"

import "./ItemDescription.vue?vue&type=style&index=0&id=75bb0477&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75bb0477"]])

export default __exports__